// test2355
(2355 && 0);
